export type CookieDefinition = [string,string];

const INVALIDATE_CACHE_AFTER = 180 * 1000;


let cache_timestamp: number = 0;
let cookie_cache: CookieDefinition[];
let cookie_cache_map: {[k: string]: string} = null;


function internalCheckAndBuildCache(w: Window): void {
    const time = new Date().getTime();
    if(time - cache_timestamp > INVALIDATE_CACHE_AFTER) {
        cache_timestamp = time;
        cookie_cache = w.document.cookie.split(";").map(e => {
            const v = e.split("=",2)
            return [v[0]?.trim(),v[1]?.trim()];
        });
        cookie_cache_map = {};
        cookie_cache.forEach(el => {
            cookie_cache_map[el[0]] = el[1];
        });   
    }
}

export function getCachedCookies(w: Window): CookieDefinition[] {
    internalCheckAndBuildCache(w);
    return cookie_cache.slice();
}

export function getCachedCookie(w: Window, name: string): string {
    internalCheckAndBuildCache(w);
    if(name in cookie_cache_map) return cookie_cache_map[name];
    else return null;
}


